const openFileInNewTab = (base64Data: any, fileName: any) => {
    // Base64 string'ini bir byte array'a dönüştür
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Byte array'ı bir Blob'a dönüştür
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Blob'dan bir ObjectURL oluştur ve yeni bir sekmede aç
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
};

export { openFileInNewTab };
